import { NetaSetting } from "constants/neta-settings";
import apiHttpClient from "libs/api-http-client";

export const getNetaSettingsAPI = (): Promise<NetaSetting> =>
  apiHttpClient.get(`neta-settings`);
